<template>
    <v-card-text class="px-3 py-0">
        <template v-if="title?.length">
            <p class="mb-4">{{ title }}</p>
        </template>
        <div :class="className">
            <slot></slot>
        </div>
    </v-card-text>
</template>

<script setup lang="ts">
export interface BuyTicketContent {
    title?: string;
    className?: string;
}

defineProps<BuyTicketContent>();
</script>
